/* unplugin-vue-components disabled */import script from "./DeleteTimerRule.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeleteTimerRule.vue?vue&type=script&lang=ts&setup=true"

import "./DeleteTimerRule.vue?vue&type=style&index=0&id=16f7b01d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16f7b01d"]])

export default __exports__